import React, { useState } from 'react';

const MoldRemediationimg = () => {

    // ✅ Separate images with captions
    const beforeImages = [
        { src: process.env.PUBLIC_URL + '/images/Pic1_1.jpg', caption: 'Before Image' },
        { src: process.env.PUBLIC_URL + '/images/Pic2.jpg', caption: 'Before Image' },

        { src: process.env.PUBLIC_URL + '/images/Pic3.jpg', caption: 'Before Image' },

        { src: process.env.PUBLIC_URL + '/images/Pic4.jpg', caption: 'Before Image' },

        { src: process.env.PUBLIC_URL + '/images/Mold-Affected-1.jpg', caption: 'Before Image' },
        { src: process.env.PUBLIC_URL + '/images/Mold-Affected-2.jpg', caption: 'Before Image' },
    ];

    const afterImages = [
        { src: process.env.PUBLIC_URL + '/images/Pic2_1.jpg', caption: 'After Image' },
        { src: process.env.PUBLIC_URL + '/images/Pic3_1.jpg', caption: 'After Image' },
        { src: process.env.PUBLIC_URL + '/images/Pic4_1.jpg', caption: 'After Image' },
        { src: process.env.PUBLIC_URL + '/images/After Remediation.jpg', caption: 'After Image' },
         { src: process.env.PUBLIC_URL + '/images/After Remediation_1.jpg', caption: 'After Image' },
    ];

    const [selectedImage, setSelectedImage] = useState(null);

    // ✅ Separate pagination states
    const [beforePage, setBeforePage] = useState(1);
    const [afterPage, setAfterPage] = useState(1);

    const imagesPerPage = 4;

    // BEFORE pagination
    const beforeLast = beforePage * imagesPerPage;
    const beforeFirst = beforeLast - imagesPerPage;
    const currentBeforeImages = beforeImages.slice(beforeFirst, beforeLast);
    const beforeTotal = Math.ceil(beforeImages.length / imagesPerPage);

    // AFTER pagination
    const afterLast = afterPage * imagesPerPage;
    const afterFirst = afterLast - imagesPerPage;
    const currentAfterImages = afterImages.slice(afterFirst, afterLast);
    const afterTotal = Math.ceil(afterImages.length / imagesPerPage);

    // ✅ Pagination generator (reuse for both)
    const getPageNumbers = (currentPage, totalPages) => {
        const maxButtons = 4;

        let start = Math.max(currentPage - 2, 1);
        let end = start + maxButtons - 1;

        if (end > totalPages) {
            end = totalPages;
            start = Math.max(end - maxButtons + 1, 1);
        }

        const pages = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    return (
        <section className='Commondefects-section  moldremediation-section'>
            <div className='container'>
                <div className='inner-content'>

                    <h2 className='section-heading'>Mold Remediation</h2>

                    <div className='row-wrapper'>

                        {/* BEFORE */}
                        <div className='left-wrap'>
                            <h3>Before Mold Remediation</h3>
                            <div className='img-box'>

                                <div className="image-grid">
                                    {currentBeforeImages.map((item, index) => (
                                        <div className='box-001-img' key={index}>
                                            <img
                                                src={item.src}
                                                alt={`before-${index}`}
                                                className="grid-image"
                                                onClick={() => setSelectedImage(item)}
                                            />
                                            <p className="caption">{item.caption}</p>
                                        </div>
                                    ))}
                                </div>

                                <div className="pagination">
                                    <button
                                        onClick={() => setBeforePage(beforePage - 1)}
                                        disabled={beforePage === 1}
                                    >
                                        Prev
                                    </button>

                                    {getPageNumbers(beforePage, beforeTotal).map((page) => (
                                        <button
                                            key={page}
                                            className={beforePage === page ? 'active' : ''}
                                            onClick={() => setBeforePage(page)}
                                        >
                                            {page}
                                        </button>
                                    ))}

                                    <button
                                        onClick={() => setBeforePage(beforePage + 1)}
                                        disabled={beforePage === beforeTotal}
                                    >
                                        Next
                                    </button>
                                </div>

                                <img src='' style={{ display: 'none' }}></img>

                            </div>
                        </div>

                        {/* AFTER */}
                        <div className='right-wrap'>
                            <h3>After Mold Remediation</h3>
                            <div className='img-box'>

                                <div className="image-grid">
                                    {currentAfterImages.map((item, index) => (
                                        <div className='box-001-img' key={index}>
                                            <img
                                                src={item.src}
                                                alt={`after-${index}`}
                                                className="grid-image"
                                                onClick={() => setSelectedImage(item)}
                                            />
                                            <p className="caption">{item.caption}</p>
                                        </div>
                                    ))}
                                </div>

                                <div className="pagination">
                                    <button
                                        onClick={() => setAfterPage(afterPage - 1)}
                                        disabled={afterPage === 1}
                                    >
                                        Prev
                                    </button>

                                    {getPageNumbers(afterPage, afterTotal).map((page) => (
                                        <button
                                            key={page}
                                            className={afterPage === page ? 'active' : ''}
                                            onClick={() => setAfterPage(page)}
                                        >
                                            {page}
                                        </button>
                                    ))}

                                    <button
                                        onClick={() => setAfterPage(afterPage + 1)}
                                        disabled={afterPage === afterTotal}
                                    >
                                        Next
                                    </button>
                                </div>

                                <img src='' style={{ display: 'none' }}></img>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ✅ Shared Modal */}
            {selectedImage && (
                <div className="modal">
                    <div className='modal-content-wrap'>
                        <span
                            className="close-btn"
                            onClick={() => setSelectedImage(null)}
                        >
                            &times;
                        </span>
                        <div className='modal-img-box'>
                            <img
                                src={selectedImage.src}
                                alt="zoomed"
                                className="modal-image"
                            />
                            <p className="caption">{selectedImage.caption}</p>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default MoldRemediationimg;